:host {
    display: block;
}

.activated-filters {
    margin-bottom: 18px;

    &.no-filters {
        display: none;
    }

    .heading {
        display: flex;
        justify-content: space-between;
        height: 53px;
        align-items: center;
        border-top: 1px solid var(--color-silver);

        .reset-filters {
            font-family: var(--primary-font);
            font-weight: var(--font-weight-regular);
            font-size: 14px;
            line-height: 27px;
            color: var(--color-nero);
            text-decoration: underline;
            text-transform: uppercase;
            cursor: pointer;
        }
    }

    .filters {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    }
}
